import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { EnrichedTurnStep } from "@/payroll/editor/types";

export const TurnSteps = ({ steps }: { steps: EnrichedTurnStep[] }) => (
  <ol
    className="space-y-3 border-l border-line pl-4"
    aria-label="Request step history"
  >
    {steps.map((step) => (
      <li key={step.key} className="min-w-0">
        <Stack direction="row" gap={2} align="baseline" wrap>
          <Text variant="body" tone="muted">
            {step.label}
          </Text>
          <Text variant="caption" tone="muted" render={<span />}>
            {step.statusLabel}
          </Text>
        </Stack>
        {!!step.detail && (
          <Text variant="body" tone="default" className="mt-1 wrap-anywhere">
            {step.detail}
          </Text>
        )}
      </li>
    ))}
  </ol>
);

export const TurnStepHistory = ({ steps }: { steps: EnrichedTurnStep[] }) => (
  <details className="min-w-0 text-sm text-subtle">
    <summary className="cursor-pointer rounded-sm py-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-focus">
      View work ({steps.length} {steps.length === 1 ? "step" : "steps"})
    </summary>
    <Stack className="pt-3">
      <TurnSteps steps={[...steps].reverse()} />
    </Stack>
  </details>
);
